export default __webpack_public_path__ + "static/media/remove_plan.4ccdbad8.svg";